<div
  class="app"
  #appShell
  [class.tablet-layout]="isTabletLayout"
  [class.tp-promos]="isTabletLayout && activeView === 'promos'"
  [class.tp-detail]="isTabletLayout && activeView === 'promos' && !!selectedPromotion"
  [class.whatson-open]="whatsOnOpen && !whatsOnClosing"
  [class.whatson-closing]="whatsOnClosing"
  [class.lang-zh]="selectedLanguage === 'zh-CN'"
  [style.--blue]="content.theme.uiColor"
  [style.--blue-deep]="content.theme.uiColor"
  [style.--gold]="content.theme.accentColor"
  [style.--gray]="content.theme.backgroundColor"
  [style.--ink]="content.theme.contentColor"
  [style.--f-body]="themeFontFamily"
>
  <!-- ===== LOADING / UNAVAILABLE / ERROR ===== -->
  <section class="view state-view active" *ngIf="content.loadState !== 'ready'">
    <div class="mini-menu-state">
      <img src="assets/images/brand/hungery-vertical.png" alt="HUNGERY">
      <div class="mini-menu-state-pulse" *ngIf="content.loadState === 'loading'"></div>
      <p>{{ menuStateMessage }}</p>
    </div>
  </section>

  <ng-container *ngIf="content.loadState === 'ready'">
    <!-- ===== TEASER ===== -->
    <section
      class="view"
      id="teaser"
      [class.active]="activeView === 'teaser' || (!isTabletLayout && (whatsOnOpen || whatsOnClosing))"
      [class.has-bg]="content.theme.landingBackground"
    >
      <div
        id="teaserBg"
        [style.background-image]="content.theme.landingBackground ? 'url(' + pickCrop(content.theme.landingBackground) + ')' : null"
      ></div>
      <div class="t-head">
        <span class="loc loc-static">{{ teaserText('location') }}</span>
        <div class="language" [class.open]="languageMenuOpen" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="lang-trigger"
            [attr.aria-label]="'Language: ' + selectedLanguageLabel"
            [attr.aria-expanded]="languageMenuOpen"
            (click)="toggleLanguageMenu($event)"
          >
            <span>{{ selectedLanguageShortLabel }}</span>
          </button>
          <div class="lang-menu" *ngIf="languageMenuOpen">
            <button
              type="button"
              *ngFor="let language of languageOptions"
              [class.active]="language.code === selectedLanguage"
              (click)="selectLanguage(language.code, $event)"
            >
              <span>{{ language.label }}</span>
              <span>{{ languageShortLabel(language.code) }}</span>
            </button>
          </div>
        </div>
        <a class="site" [href]="content.businessPageUrl || 'https://hungery.id'" target="_blank" rel="noopener noreferrer">Hungery.id</a>
      </div>
      <div class="t-center">
        <img
          class="mark custom-logo"
          id="brandLogo"
          *ngIf="content.theme.landingLogoUrl"
          [src]="content.theme.landingLogoUrl"
          [alt]="content.businessName"
        >
        <span
          class="mark logo-mask"
          *ngIf="!content.theme.landingLogoUrl"
          role="img"
          [attr.aria-label]="content.businessName"
          [style.--logo-mask]="landingLogoMaskStyle"
        ></span>
        <div class="t-copy">
          <div class="ey">{{ teaserText('eyebrow') }}</div>
          <p
            class="sub"
            #sublineText
            [miniMenuExpandable]="sublineExpanded"
          ><strong class="sub-name" *ngIf="sublineLead">{{ sublineLead }}</strong>{{ sublineRest }}</p>
          <button
            type="button"
            class="sub-more"
            *ngIf="sublineOverflows"
            [attr.aria-expanded]="sublineExpanded"
            (click)="toggleSubline($event)"
          >{{ sublineExpanded ? ui('less') : ui('more') }}</button>
        </div>
      </div>
      <div class="t-actions">
        <button type="button" class="t-row" *ngIf="livePromotions.length" (click)="openWhatsOn()">
          <span class="lbl">{{ ui('whatsOn') }}</span><span class="arr">→</span>
        </button>
        <button type="button" class="t-row" *ngIf="showMenuAction" (click)="go('menu')">
          <span class="lbl">{{ ui('menu') }}</span><span class="arr">→</span>
        </button>
      </div>
    </section>

    <!-- ===== MENU ===== -->
    <section class="view" id="menu" [class.active]="activeView === 'menu'">
      <div class="topbar">
        <button type="button" class="back-title" (click)="go('teaser')">
          <span class="back-ic">←</span>
          <span class="tt">{{ ui('menu') }}</span>
        </button>
        <img
          class="logo-mini custom-logo"
          *ngIf="content.theme.bannerLogoUrl"
          [src]="content.theme.bannerLogoUrl"
          [alt]="content.businessName"
        >
        <span
          class="logo-mini logo-mask"
          *ngIf="!content.theme.bannerLogoUrl"
          aria-hidden="true"
          [style.--logo-mask]="logoMaskStyle"
        ></span>
      </div>
      <div class="scroll pill-scroll" id="menuScroll" [class.scrolling]="menuScrolling" (scroll)="onMenuScroll($event)">
        <div id="menuList">
          <div class="empty menu-empty" *ngIf="!menuCategories.length">
            <div class="n">· · ·</div>
            <p>{{ menuStateMessage }}</p>
          </div>
          <div
            class="menu-group"
            *ngFor="let category of menuCategories; trackBy: trackByCategory"
            [attr.data-group]="categoryName(category)"
            [id]="'mini-menu-' + category.id"
          >
            <h3>{{ categoryName(category) }}</h3>
            <div
              class="item"
              *ngFor="let product of category.products; trackBy: trackByProduct"
              [class.has-media]="productImage(product)"
            >
              <!-- Evolution product photography. Square frame, hard edges — the MiniMenu
                   design language carries no rounded or feathered image treatments. -->
              <div class="item-media" *ngIf="productImage(product) as imageUrl">
                <img [src]="imageUrl" [alt]="productText(product, 'name')" loading="lazy">
              </div>

              <div class="item-main">
                <!-- Name and price share the top line so the description and modifiers can
                     use the full width beside the photo instead of a squeezed column. -->
                <div class="item-head">
                  <div class="item-name">{{ productText(product, 'name') }}</div>
                  <span class="item-price">{{ formatPrice(product.price) }}</span>
                </div>
                <div
                  class="item-desc"
                  *ngIf="productText(product, 'description')"
                  [miniMenuExpandable]="isDescriptionExpanded(product)"
                  [attr.aria-expanded]="isDescriptionExpanded(product)"
                  tabindex="0"
                  (click)="toggleDescription(product, $event)"
                  (keydown.enter)="toggleDescription(product, $event)"
                  (keydown.space)="toggleDescription(product, $event)"
                >{{ productText(product, 'description') }}</div>

                <div class="mods" *ngIf="hasModifiers(product)">
                  <!-- Loose singles: no group exists, so there is no title to print. -->
                  <div class="mod-row mod-loose" *ngIf="looseModifiers(product).length">
                    <span class="mod-opts">
                      <span
                        class="mod-opt"
                        *ngFor="let option of looseModifiers(product); trackBy: trackByModifierOption"
                      >{{ option.name }}<em>{{ formatModifierPrice(option.priceDelta) }}</em></span>
                    </span>
                  </div>

                  <!-- Named groups, then the groups each set contributes. A set is only an
                       authoring bundle, so its groups read as ordinary titled groups. -->
                  <div
                    class="mod-row"
                    *ngFor="let group of modifierGroups(product); trackBy: trackByModifierGroup"
                  >
                    <span class="mod-name">{{ modifierGroupName(group) }}</span>
                    <span class="mod-opts">
                      <span
                        class="mod-opt"
                        *ngFor="let option of group.options; trackBy: trackByModifierOption"
                      >{{ option.name }}<em>{{ formatModifierPrice(option.priceDelta) }}</em></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="barpad"></div>
      </div>
      <div class="cats" id="cats">
        <button
          type="button"
          class="cat"
          *ngFor="let category of menuCategories; trackBy: trackByCategory"
          [id]="'mini-menu-cat-' + category.id"
          [class.active]="activeCategoryId === category.id"
          (click)="scrollToCategory(category.id)"
        >
          {{ categoryName(category) }}
        </button>
      </div>
    </section>

    <!-- ===== WHAT'S ON ===== -->
    <section class="view" id="promos" [class.active]="activeView === 'promos'">
      <div class="topbar">
        <button type="button" class="back-title" (click)="collapseWhatsOn()">
          <span class="back-ic">←</span>
          <span class="tt">{{ ui('back') }}</span>
        </button>
        <img
          class="logo-mini custom-logo"
          *ngIf="content.theme.bannerLogoUrl"
          [src]="content.theme.bannerLogoUrl"
          [alt]="content.businessName"
        >
        <span
          class="logo-mini logo-mask"
          *ngIf="!content.theme.bannerLogoUrl"
          aria-hidden="true"
          [style.--logo-mask]="logoMaskStyle"
        ></span>
      </div>
      <div class="scroll" (scroll)="whatsOnActivity()">
        <div class="promo-list" id="promoList">
          <div
            class="promo-row"
            *ngFor="let promotion of livePromotions; let i = index; trackBy: trackByPromotion"
            (click)="openPromotion(promotion)"
          >
            <span class="idx">{{ promotionIndex(i) }}</span>
            <div class="pr-main">
              <!-- badge / when are not populated in Evolution yet: render nothing rather
                   than an empty line, so rows stay tight until those fields land. -->
              <span class="badge" *ngIf="promotionText(promotion, 'badge')">{{ promotionText(promotion, 'badge') }}</span>
              <h3>{{ promotionText(promotion, 'title') }}</h3>
              <div class="when" *ngIf="promotionText(promotion, 'when')">{{ promotionText(promotion, 'when') }}</div>
            </div>
            <span class="arr">→</span>
          </div>
        </div>
      </div>
      <div id="promoDetail" [class.active]="selectedPromotion">
        <ng-container *ngIf="selectedPromotion as promotion">
          <div class="pd-top" *ngIf="!isTabletLayout">
            <button type="button" class="back-title" (click)="closePromotion()">
              <span class="back-ic">←</span>
              <span class="badge">{{ ui('back') }}</span>
            </button>
          </div>
          <div class="pd-scroll">
            <div
              class="pd-image"
              *ngIf="promotion.image"
              [style.background-image]="'url(' + pickCrop(promotion.image) + ')'"
            ></div>
            <div class="pd-body">
              <h2>{{ promotionText(promotion, 'title') }}</h2>
              <div class="pd-when" *ngIf="promotionText(promotion, 'when')">{{ promotionText(promotion, 'when') }}</div>
              <p class="lead" *ngIf="promotionText(promotion, 'lead')">{{ promotionText(promotion, 'lead') }}</p>
              <p *ngFor="let paragraph of promotionBody(promotion)">{{ paragraph }}</p>
              <div class="pd-act">
                <button type="button" class="txt-btn" (click)="go('menu')">{{ ui('menu') }} →</button>
              </div>
              <button type="button" class="pd-back txt-btn" *ngIf="isTabletLayout" (click)="closePromotion()">← {{ ui('back') }}</button>
            </div>
          </div>
        </ng-container>
      </div>
    </section>
  </ng-container>
</div>
